import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@mdi/font/css/materialdesignicons.css';
import router from './router';
import Axios from 'axios';
import { store } from './store';
import { i18n } from '@/plugins/i18n';
import { Trans } from './plugins/Translation';
import Router from 'vue-router';
import VueCountryCode from 'vue-country-code';
import VueQrcode from '@chenfengyuan/vue-qrcode';
import VueHtmlToPaper from 'vue-html-to-paper';
import DatetimePicker from 'vuetify-datetime-picker';
import Lightbox from 'vue-easy-lightbox';
import Permissions from '@/plugins/permissions';
import timeTransform from '@/plugins/timeTransform';
import { refreshToken } from './utils/refreshToken';
// import VuetifulBoard from 'vuetiful-board'

// Vue.use(VuetifulBoard)

const options = {
  name: '_blank',
  specs: ['fullscreen=yes', 'titlebar=yes', 'scrollbars=yes'],
  styles: [
    'https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900',
    'https://cdn.jsdelivr.net/npm/@mdi/font@4.x/css/materialdesignicons.min.css',
    'https://cdn.jsdelivr.net/npm/vuetify@2.x/dist/vuetify.min.css',
  ],
};

Vue.component(VueQrcode.name, VueQrcode);

Vue.config.productionTip = false;
Vue.prototype.$msalInstance = {};
Vue.prototype.$http = Axios;
Vue.prototype.$i18nRoute = Trans.i18nRoute.bind(Trans);
Vue.use(VueCountryCode);
Vue.use(VueHtmlToPaper, options);
Vue.use(DatetimePicker);
Vue.use(Lightbox);
Vue.use(Permissions);
Vue.use(timeTransform);

const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((error) => error);
};

Vue.directive('scroll', {
  inserted: function(el, binding) {
    let f = function(evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f);
      }
    };
    window.addEventListener('scroll', f);
  },
});

async function initApp() {
  await refreshToken();

  new Vue({
    vuetify,
    router,
    store,
    i18n,
    render: (h) => h(App),
  }).$mount('#app');
}

initApp();
